import { ChartOptionsModalComponent } from './ChartOptionsModal.component';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ITemplate } from '../../template-preview/template-preview.component';
import { FormGroup } from '@angular/forms';
import { MobileChartOptionsModalComponent } from '../mobile-chart-options-modal/mobile-chart-options-modal.component';

export function ShowNewTemplateModal(modalService: NgbModal, baseTemplate?: ITemplate, mobileMode = 'desktop', editMode = false): Promise<any> {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileChartOptionsModalComponent: ChartOptionsModalComponent;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    const m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    const modal = (<ChartOptionsModalComponent>m.componentInstance);
    modal.initFormTemplate(baseTemplate || { name: ''}, editMode);
    return m.result;
}